<mat-card class="login-card">
    <h2>Login</h2>
    <p *ngIf="errorMessage" class="error-message">{{ errorMessage }}</p>
    <form [formGroup]="loginForm" (ngSubmit)="handleSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
        <mat-error *ngIf="loginForm.controls['email'].invalid && (loginForm.controls['email'].dirty || loginForm.controls['email'].touched)">
          {{ getEmailErrorMessage() }}
        </mat-error>
      </mat-form-field>
  
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" />
        <mat-error *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)">
          {{ getPasswordErrorMessage() }}
        </mat-error>
      </mat-form-field>
  
      <button mat-raised-button color="primary" type="submit">Login</button>
    </form>
  </mat-card>
  